export default __webpack_public_path__ + "static/media/Hombre_6.2fe47022.svg";